import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Setting';

const electronicForm = [
    {
        matchRegex: '/CompanyForm',
        name: getRouteName(MODULE_NAME, 'Electronic Forms'),
        slots: [SLOT_KEY.SLOT_TAB],
    },
];

export default electronicForm;
